export type ManualDiscountMode = 'on' | 'off' | 'default';

// 'default' (or unset on users created before this setting existed) falls back to the tenant default
export const isManualDiscountEnabled = (mode: ManualDiscountMode | undefined, tenantDefault: boolean): boolean =>
  mode === 'on' || (mode !== 'off' && tenantDefault);